var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.metas_list,"item-text":"metas_title","item-value":"id","label":_vm.$t('Metas Input'),"placeholder":_vm.$t('Select Metas'),"dense":"","outlined":""},model:{value:(_vm.metas_selected),callback:function ($$v) {_vm.metas_selected=$$v},expression:"metas_selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }